import {USER_TYPE_AUDITOR} from "../constants";
import {PERMISSIONS_AUDITOR} from "../constants/permissions";
import {apiRequest, apiRequestAdmin} from "../api/ws";
import {account$, getUserMainPage, loadingSignOut$, onAccount} from "../emitters/account";
import {pushLocation} from "../router";
import {
  ENDPOINT_ACCOUNT_AVATAR,
  ENDPOINT_ACCOUNT_SUBACCCOUNTS_LIST,
  ENDPOINT_ACCOUNT_SWITCH,
  ENDPOINT_AUTH_EMAIL_CONFIRM,
  ENDPOINT_AUTH_EMAIL_RESEND,
  ENDPOINT_AUTH_PWD_RECOVERY,
  ENDPOINT_AUTH_RECOVERY_TOKEN, ENDPOINT_AUTH_SIGN_IN,
  ENDPOINT_AUTH_SIGN_OUT, ENDPOINT_AUTH_SIGN_UP,
  ENDPOINT_AUTH_SWITCH,
  ENDPOINT_AUTH_TFA_BIND,
  ENDPOINT_AUTH_TFA_CONFIRM,
  ENDPOINT_AUTH_TFA_VERIFY,
  ENDPOINT_AUTH_USER
} from "../constants/api";

const delay = require('mn-utils/delay');
const toLower = require('mn-utils/toLower');
const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const {
  post,
} = require('./http');
const {
  USER_TYPE_ADMIN,
  USER_TYPE_MERCHANT,
  USER_TYPE_OPERATOR,
  DEFAULT_CURRENCY,
  DEFAULT_AVATAR_CORP,
} = require('../constants');
const {
  LINK_SIGN_IN,
} = require('../constants/links');
const {
  replaceLocation,
} = require('../router');
const isErrorNoConnect = require('../utils/isErrorNoConnect');
const {
  localStore,
} = require('../stores');
const MOCK_TYPES = {
  'admin@lunu.io': USER_TYPE_ADMIN,
};

function isVerified(v) {
  const status = toLower(v.status || '');
  return status === 'approved' || status === 'ready';
}

export function apiAuthGetMerchantAccounts(params) {
  return apiRequest(ENDPOINT_ACCOUNT_SUBACCCOUNTS_LIST, params, () => {
    userSignUp$.emit(params);
    return {};
  });
}

export function getAccountsList(account) {
  return new Promise((resolve) => {
    apiAuthGetMerchantAccounts()
        .then((res) => {
          if (!res.list || !res.list.length) return [];
          return (res.list || []).map(({id, login, name}) => {
            return {id, login, name, disabled: id === account.id}
          }).sort((prev, next) => !!next.disabled ? 1 : -1);
        })
        .then((accountsList) => {
          resolve({
            ...account,
            accountsList
          })
        });
  });
}

export function handleUser(user) {
  if (!user) {
    return 0;
  }

  // const access_settings = user.access_settings || {};

  const accountType = user.account_type;
  const account = {
    ...user,
    avatar: user.has_avatar
      ? (
        process.env.MOCK
          ? DEFAULT_AVATAR_CORP
          : `${ENDPOINT_ACCOUNT_AVATAR}?t=${(new Date).getTime()}`
      )
      : null,
    // access_settings: {
    //   ...access_settings,
    //   dashboard: false,
    //   edit_bank_details: false,
    //   change_aml_preference: false,
    //   settlements_and_refund_preference: false
    // },
    admin: accountType === USER_TYPE_ADMIN,
    auditor: accountType === USER_TYPE_AUDITOR,
    merchant: accountType === USER_TYPE_MERCHANT,
    operator: accountType === USER_TYPE_OPERATOR,
    verified: isVerified(user),
  };

  return account.need_tfa ? account : getAccountsList(account);
}

export const user$ = localStore('mockUser', 0);
const {
  emit: emitUser,
  getValue: getUser,
} = user$;
export const userSignUp$ = localStore('mockSignUp', 0);


export function apiAuthSignUpMerchant(params) {
  return post(ENDPOINT_AUTH_SIGN_UP, params, () => {
    userSignUp$.emit(params);
    return {};
  });
}
export function apiAuthSignIn(params) {
  return post(ENDPOINT_AUTH_SIGN_IN, params, () => {
    // mock
    const {
      email,
    } = params;
    const accountType = MOCK_TYPES[email] || USER_TYPE_MERCHANT;
    const response = {
      // blocked: true,
      // need_tfa: true,
      status: 'approved',
      has_avatar: true,
      version: 'local mock',
      username: email,
      fullname: 'Liza',
      fiat_code: DEFAULT_CURRENCY,
      company: 'Thyssen-Bornemisza Art Contemporary Academy',
      account_type: accountType,
    };
    user$.emit(response);
    return response;
  }).then(handleUser, (error) => {
    if (error.code === 149) {
      return {blocked: 1};
    }
    throw error;
  });
}


export function apiReloginMerchant(params) {
  loadingSignOut$.emit(true);

  setTimeout(() => {
    return apiRequest(ENDPOINT_ACCOUNT_SWITCH, params, () => {})
      .then(({item}) => {
        apiRequest && apiRequest.reset();
        apiRequestAdmin && apiRequestAdmin.reset();

        return item;
      })
      .then(handleUser)
      .then(onAccount)
      .then((routeSwitched) => {
        if (!routeSwitched) {
          pushLocation({
            path: getUserMainPage(),
          });
        }
      })
      .finally(() => loadingSignOut$.emit(false));
  }, 1000);
}

export function apiAuthAdminToMerchant({id}) {
  return post(ENDPOINT_AUTH_SWITCH, {login_site: {console: id}}, () => {})
    .then(handleUser, (error) => {
      if (error.code === 149) {
        return {blocked: 1};
      }
      throw error;
    });
}
export function apiAuthMerchantToAdmin() {
  return post(ENDPOINT_AUTH_SWITCH, {login_site: 'default'}, () => {})
    .then(handleUser, (error) => {
      if (error.code === 149) {
        return {blocked: 1};
      }
      throw error;
    });
}

export function apiAuthSignOut() {
  return post(ENDPOINT_AUTH_SIGN_OUT, null, () => {
    emitUser(0);
    return {};
  }).then(() => {
    apiRequest && apiRequest.reset();
    apiRequestAdmin && apiRequestAdmin.reset();
  });
}
export function apiAuthPasswordRecovery(params) {
  return post(ENDPOINT_AUTH_PWD_RECOVERY, params);
}

export function apiAuthRecoveryToken(params) {
  return post(ENDPOINT_AUTH_RECOVERY_TOKEN, params);
}

export function apiAuthUser(params) {
  return post(ENDPOINT_AUTH_USER, params, getUser).then(handleUser);
}

export function apiAuthEmailConfirm(params) {
  return post(ENDPOINT_AUTH_EMAIL_CONFIRM, params, () => {
    // mock
    const user = userSignUp$.getValue();
    emitUser({
      username: user.email,
    });
    return {
      token: user.action,
    };
  });
}
export function apiAuthResendConfirmationV2(params) {
  return post(ENDPOINT_AUTH_EMAIL_RESEND, params, () => {
    // mock
    userSignUp$.emit(params);
    return {};
  });
}
export function apiAuthTfaBind(params) {
  return post(ENDPOINT_AUTH_TFA_BIND, params, () => {
    // mock
    return {
      secret: 'I53SISZC2UJQZCYIMBI2PIAF5ZMT47JA',
      qrcode_url: 'https://img-android.lisisoft.com/imgmic/2/4/3942-i-com.notes.education.test.educationalapp.jpg',
    };
  });
}
export function apiAuthTfaConfirm(params) {
  return post(ENDPOINT_AUTH_TFA_CONFIRM, params);
}

export function apiAuthTfaVerify(params) {
  params = params || {};
  const handleError = params.handleError;
  return post(ENDPOINT_AUTH_TFA_VERIFY, {
    ...params,
    handleError(error) {
      const {
        code,
      } = error;
      if (code === 149 || code === 108) {
        return {
          blocked: 1,
        };
      }
      if (handleError) {
        return handleError(error);
      }
      throw error;
    },
  }, () => {
    // mock
    emitUser({
      ...getUser(),
      need_tfa: 0,
    });
    return {};
  });
}

export const auth$ = new Emitter();
export const loadingSession$ = new Emitter();
export const loadingReconnect$ = new Emitter();
let promiseCheckSession = new CancelablePromise();
export const handleReconnectMerchant = handleReconnectProvider(USER_TYPE_MERCHANT);
export const handleReconnectAdmin = handleReconnectProvider(USER_TYPE_ADMIN);

export function handleReconnectProvider(accountType) {
  return (error) => {
    loadingReconnect$.emit(1);
    return checkSessionWithoutLoading().then((user) => {
      if (user) {
        if (user.account_type === accountType) {
          return user;
        }
        refreshSession();
        throw new Error('Incorrect account type');
      }
      refreshSession();
      throw new Error('Session expired');
    }).finally(loadingReconnect$.bind(0));
  };
}
export function reconnectTimeout() {
  return CancelablePromise.delay(10000);
}
export function decorateReconnect(request, _checkSession) {
  const reconnect = _checkSession
    ? (() => _checkSession().catch((error) => {
      if (isErrorNoConnect(error)) {
        return reconnectTimeout().then(reconnect);
      }
      throw error;
    }))
    : reconnectTimeout;

  return (params) => {
    function base() {
      return request(params).catch((error) => {
        // console.log('decorateReconnect', err.message);
        if (isErrorNoConnect(error)) {
          return reconnect().then(base);
        }
        throw error;
      });
    }
    return base();
  };
}
export function checkSessionWithoutLoading() {
  if (loadingSession$.getValue()) {
    return promiseCheckSession;
  }
  loadingSession$.emit(1);
  return promiseCheckSession = decorateReconnect(apiAuthUser)()
      .finally(loadingSession$.bind(0));
}
function checkSession() {
  loadingReconnect$.emit(1);
  return checkSessionWithoutLoading()
      .then((v) => {
        if (v) {
          return v;
        }
        refreshSession();
        throw new Error('Session expired');
      })
      .finally(loadingReconnect$.bind(0));
}
export function decorateReconnectIfSession(request) {
  return (params) => {
    function base() {
      return request(params).catch((error) => {
        // console.log('decorateReconnect', err.message);
        if (isErrorNoConnect(error)) {
          return checkSession().then(base);
        }
        throw error;
      });
    }
    return base();
  };
}
export function refreshSession() {
  auth$.emit(0);
  replaceLocation({
    path: LINK_SIGN_IN,
  });
  delay(() => {
    window.location.reload();
  }, 100);
}
